// src/confluence/page/types.ts
var ConfluencePageAriResourceOwner = "confluence", ConfluencePageAriResourceType = "page";

export {
  ConfluencePageAriResourceOwner,
  ConfluencePageAriResourceType
};
